import React from 'react';
import { Box, Typography, Link, Container } from '@mui/material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 3, 
        px: 2, 
        mt: 'auto',
        backgroundColor: 'rgba(10, 10, 10, 0.7)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.08)',
      }}
    >
      <Container maxWidth="lg">
        <Typography 
          variant="body2" 
          color="text.secondary" 
          align="center"
          sx={{
            opacity: 0.8,
            '&:hover': {
              opacity: 1
            },
            transition: 'opacity 0.3s ease'
          }}
        >
          {'© '}
          {new Date().getFullYear()}
          {' '}
          <Link 
            color="primary" 
            href="#"
            sx={{ 
              textDecoration: 'none',
              fontWeight: 500,
              transition: 'text-shadow 0.3s ease',
              '&:hover': {
                textShadow: '0 0 8px rgba(76, 194, 255, 0.6)'
              }
            }}
          >
            Email Generator
          </Link>
          {' | '}
          <Typography 
            component="span" 
            variant="body2" 
            color="text.secondary"
          >
            A simple tool to create multiple Gmail aliases using the dot trick
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer; 